import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import ProductSection from '../../components/ProductSection/ProductSection';
import CTA from '../../components/CTA/CTA';
class Software extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="software" />
        <ServiceBanner product {...this.props} service page="software" />
        <ProductSection yellowBar noPadBottom {...this.props} page="software" section="benefits">
          <TextGroup {...this.props} page="software" section="benefits" />
        </ProductSection>
        <ProductSection yellowBar noPadBottom {...this.props} page="software" section="methodology">
          <TextGroup {...this.props} page="software" section="methodology" />
        </ProductSection>
        <ProductSection noTitle noPadTitle noImg yellowBar  {...this.props} page="software" >
          <CTA noBG {...this.props} />
        </ProductSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Software);